import { Stack, Typography, Box } from "@mui/material";
import React, { useContext } from "react";

import { useNavigate } from "react-router-dom";

import { ThemeModeContext } from "../../shared/Theme";
import { darkGrey } from "../../shared/colours";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

const AdditionalServiceCard = (props) =>
{
	const navigate = useNavigate();
	const themeModeContext = useContext(ThemeModeContext);

	const handleTitleClick = () =>
	{
		if (typeof props.onClick === "function")
		{
			props.onClick(props.title);
		}
	};

	return (
		<React.Fragment>
			<Stack
				direction="column"
				spacing={0.1}
				alignItems="center"
				justifyContent="center"
				sx={{
					width: "20em",
					height: "13em",
					border: `solid 2px ${darkGrey}`,
					borderRadius: "1.5em",
					"&:hover": { cursor: "pointer" },
				}}
			>
				<Box
					sx={{
						height: "1em",
						width: "100%",
						textAlign: "right",
					}}
				>
					{props.helpToggle && (
						<HelpOutlineRoundedIcon
							onClick={props.helpToggle}
							sx={{
								position: "relative",
								top: "0.4em",
								right: "0.4em",
								width: "1em",
								height: "1em",
							}}
						/>
					)}
				</Box>
				<Box
					sx={{
						height: "100%",
						width: "100%",
						paddingLeft: "0.5em",
						paddingRight: "0.5em",
						paddingBottom: "0.8em",
					}}
				>
					<Typography
						variant="h6"
						sx={{
							textAlign: "center",
							cursor: "pointer",
							fontWeight: "bold",
						}}
						onClick={handleTitleClick}
					>
						{props.icon && (
							<>
								<img src={props.icon} height="100em" alt={props.title} />
								<br />
							</>
						)}
						{props.title}
					</Typography>
				</Box>
			</Stack>
		</React.Fragment>
	);
};

export default AdditionalServiceCard;
